export const AUTH_MENU_LOGOUT = 'authMenuLogout';